export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-regular-oblique-web-0470655557dc483d0a3d55b730d6240f.ttf";